import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next';
import { Container, Row } from "reactstrap";
import { Col } from "react-bootstrap";
import { Breadcrumbs } from '../../AbstractElements';
import HomePackage from './HomePackage';

export default function PackageList() {
    const { t } = useTranslation();
    return (
        <Fragment>
            <Breadcrumbs mainTitle={t("List of Test Packages")} parent={t("Home")} title={t("List of Test Packages")} />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <HomePackage />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
